import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { fetchAllUserProducts } from "../productsAPI";

export const useFetchAllUserProducts = (userId = 0) => {
  return useQuery({
    enabled: Boolean(userId),
    queryKey: [
      QUERY_KEYS.FETCH_USER_PRODUCTS,
      {
        userId,
      },
    ],
    queryFn: async () => {
      return await fetchAllUserProducts(userId);
    },
  });
};
